function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs4"
}, React.createElement("clipPath", {
  id: "clipPath2510"
}, React.createElement("path", {
  d: "M 0,0 H 1776.189 V 841.89 H 0 Z",
  id: "path2512"
})), React.createElement("clipPath", {
  id: "clipPath2502"
}, React.createElement("path", {
  d: "M 0,0 H 1776.189 V 841.89 H 0 Z",
  id: "path2504"
})), React.createElement("clipPath", {
  id: "clipPath2494"
}, React.createElement("path", {
  d: "M 0,0 H 1776.189 V 841.89 H 0 Z",
  id: "path2496"
})), React.createElement("clipPath", {
  id: "clipPath2486"
}, React.createElement("path", {
  d: "M 0,0 H 1776.189 V 841.89 H 0 Z",
  id: "path2488"
})), React.createElement("clipPath", {
  id: "clipPath2466"
}, React.createElement("path", {
  d: "m 62.158,794.821 h 81.221 v 34.556 H 62.158 Z",
  id: "path2468"
})), React.createElement("clipPath", {
  id: "clipPath2442"
}, React.createElement("path", {
  d: "m 595.275,23.015 h 32.882 V 75.25 h -32.882 z",
  id: "path2444"
})), React.createElement("clipPath", {
  id: "clipPath2836"
}, React.createElement("path", {
  d: "M 0.03,898.59 H 2409.45 V 0.03 H 0.03 Z",
  id: "path2838"
})), React.createElement("clipPath", {
  id: "clipPath2828"
}, React.createElement("path", {
  d: "M 0,898 H 2409 V 0 H 0 Z",
  id: "path2830"
})), React.createElement("clipPath", {
  id: "clipPath2820"
}, React.createElement("path", {
  d: "M 0.03,898.59 H 2409.45 V 0.03 H 0.03 Z",
  id: "path2822"
})), React.createElement("clipPath", {
  id: "clipPath2812"
}, React.createElement("path", {
  d: "M 0,898 H 2409 V 0 H 0 Z",
  id: "path2814"
})), React.createElement("clipPath", {
  id: "clipPath2678"
}, React.createElement("path", {
  d: "M 0.03,898.59 H 2409.45 V 0.03 H 0.03 Z",
  id: "path2680"
})), React.createElement("clipPath", {
  id: "clipPath2670"
}, React.createElement("path", {
  d: "M 0,898 H 2409 V 0 H 0 Z",
  id: "path2672"
})), React.createElement("clipPath", {
  id: "clipPath2656"
}, React.createElement("path", {
  d: "M 0.03,898.59 H 2409.45 V 0.03 H 0.03 Z",
  id: "path2658"
})), React.createElement("clipPath", {
  id: "clipPath2648"
}, React.createElement("path", {
  d: "M 0,898 H 2409 V 0 H 0 Z",
  id: "path2650"
})), React.createElement("clipPath", {
  id: "clipPath2640"
}, React.createElement("path", {
  d: "M 587.253,449 H 885.6 V 19.551 H 587.253 Z",
  id: "path2642"
})));

var SvgWoltersKluwerLogo = function SvgWoltersKluwerLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 239.88188,
    height: 239.88188,
    id: "svg2",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", {
    transform: "translate(-201.55886,-27.991585)",
    id: "layer1"
  }, React.createElement("g", {
    transform: "translate(35.433068,35.498355)",
    id: "g3214"
  }, React.createElement("path", {
    d: "m 266.09713,52.741869 v -22.41759 c -15.31533,3.70734 -28.99915,11.63577 -39.78792,22.41759 h 39.78792",
    id: "path2684",
    style: {
      fill: "#469dd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 305.89193,52.741869 v -22.41759 c 15.32228,3.70734 29.01304,11.63577 39.79487,22.41759 h -39.79487",
    id: "path2688",
    style: {
      fill: "#0081c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 286.07093,27.991579 c -6.85233,0 -13.58663,0.79839 -19.9738,2.3327 v 22.41759 h 39.79486 v -22.39676 c -6.38023,-1.53431 -12.98262,-2.35353 -19.82106,-2.35353",
    id: "path2692",
    style: {
      fill: "#a0c2e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 305.89193,172.12646 v 22.41064 c 15.32228,-3.70734 29.01304,-11.63576 39.79487,-22.41064 h -39.79487",
    id: "path2696",
    style: {
      fill: "#0081c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 266.09713,172.12646 v 22.41064 c -15.31533,-3.70734 -28.99915,-11.63576 -39.78792,-22.41064 h 39.78792",
    id: "path2700",
    style: {
      fill: "#0081c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 285.92502,196.87675 c 6.85927,0 13.58663,-0.7984 19.96686,-2.33965 v -22.41064 h -39.79486 v 22.38981 c 6.38717,1.54126 12.97568,2.36048 19.828,2.36048",
    id: "path2704",
    style: {
      fill: "#469dd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 345.6868,92.529789 h 22.41758 c -3.70733,-15.30839 -11.62882,-28.99915 -22.41758,-39.78792 v 39.78792",
    id: "path2708",
    style: {
      fill: "#0081c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 345.6868,132.33159 h 22.41758 c -3.70733,15.31533 -11.62882,29.0061 -22.41758,39.79487 v -39.79487",
    id: "path2712",
    style: {
      fill: "#0081c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 370.44409,112.50359 c 0,-6.85233 -0.7984,-13.593571 -2.33965,-19.973801 h -22.41759 v 39.801801 h 22.38982 c 1.54819,-6.38023 2.36742,-12.98262 2.36742,-19.828",
    id: "path2716",
    style: {
      fill: "#469dd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 226.30915,132.33159 h -22.41064 c 3.69345,15.31533 11.62882,29.0061 22.41064,39.79487 v -39.79487",
    id: "path2720",
    style: {
      fill: "#0081c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 226.30915,92.529789 h -22.41064 c 3.69345,-15.30839 11.62882,-28.99915 22.41064,-39.78792 v 39.78792",
    id: "path2724",
    style: {
      fill: "#469dd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 201.55886,112.35785 c 0,6.85927 0.7984,13.59357 2.33965,19.9738 h 22.41064 V 92.529849 h -22.38981 c -1.5482,6.38023 -2.36048,12.989561 -2.36048,19.828001",
    id: "path2728",
    style: {
      fill: "#a0c2e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 226.30915,92.529789 h 39.78792 v -39.79486 h -39.78792 z",
    id: "path2730",
    style: {
      fill: "#93cc84",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 226.30915,132.33159 h 39.78792 V 92.529789 h -39.78792 z",
    id: "path2732",
    style: {
      fill: "#c6e3bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 226.30915,172.12646 h 39.78792 v -39.79487 h -39.78792 z",
    id: "path2734",
    style: {
      fill: "#6ebf5d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 266.09707,92.529789 h 39.79486 v -39.79486 h -39.79486 z",
    id: "path2736",
    style: {
      fill: "#c6e3bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 266.09707,132.33159 h 39.79486 V 92.529789 h -39.79486 z",
    id: "path2738",
    style: {
      fill: "#e4105b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "m 266.09707,172.12646 h 39.79486 v -39.79487 h -39.79486 z",
    id: "path2740",
    style: {
      fill: "#93cc84",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "M 305.89193,92.529789 H 345.6868 V 52.734929 H 305.89193 Z",
    id: "path2742",
    style: {
      fill: "#6ebf5d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "M 305.89193,132.33159 H 345.6868 V 92.529789 h -39.79487 z",
    id: "path2744",
    style: {
      fill: "#93cc84",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "M 305.89193,172.12646 H 345.6868 V 132.33159 H 305.89193 Z",
    id: "path2746",
    style: {
      fill: "#6ebf5d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWoltersKluwerLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wolters_Kluwer_Logo.834fa9c3.svg";
export { ForwardRef as ReactComponent };